import React from 'react';
import './Features.css';

const Features: React.FC = () => {
  const features = [
    {
      icon: '🎨',
      title: 'WebGPU 3D Visualization',
      description: 'GPU-accelerated 3D visualization of neural network architectures with interactive controls. Watch activations flow through your network in real-time.'
    },
    {
      icon: '🔗',
      title: 'Drag-and-Drop Model Builder',
      description: 'Build neural networks visually with our intuitive model builder. Support for CNN, Transformer, MLP, RNN, LSTM, and more.'
    },
    {
      icon: '📊',
      title: 'Real-time Training Monitoring',
      description: 'Track training progress, loss, accuracy, and layer activations in real-time with live WebSocket updates from your training backend.'
    },
    {
      icon: '⚙️',
      title: 'Pipeline Builder',
      description: 'Automate your ML workflow with our pipeline builder. From data preprocessing to model deployment, streamline your entire process.'
    },
    {
      icon: '🔌',
      title: 'API Integration',
      description: 'Deploy and run your trained models via RESTful API. Easy integration with your applications and services.'
    },
    {
      icon: '🗄️',
      title: 'Data Management',
      description: 'Upload, organize, and label your datasets. Built-in data labeling tools and dataset management for efficient ML workflows.'
    }
  ];

  return (
    <section id="features" className="features-section">
      <div className="features-container">
        <div className="features-header">
          <div className="features-label">Powerful Features</div>
          <h2 className="features-title">Everything you need for ML development</h2>
          <p className="features-subtitle">
            From building architectures to training and deployment, MLblocks provides a complete platform 
            for neural network development with real-time visualization and monitoring.
          </p>
        </div>
        <div className="features-image-wrapper" data-aos="fade-up">
          <img
            src="/images/features.png"
            alt="Features"
            className="features-image"
          />
        </div>
        <div className="features-grid">
          {features.map((feature, index) => (
            <article key={index} className="feature-card" data-aos="fade-up" data-aos-delay={index * 100}>
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;

